export default __webpack_public_path__ + "static/media/slide-5.b21c0308.webp";